import { useQuery } from "@tanstack/react-query" 

export function useCompositeQuery({
  dispute,
  rp,
  subdomain,
  renderPkg,
  callback
}:{
  dispute:string 
  rp:string
  subdomain:string
  renderPkg?:any
  callback?:any
}){

  const queryEnabled = !!(dispute && rp && subdomain && !renderPkg)

  // if(!renderPkg){
  //   console.log("Dispute query has already been run")
  // }

  const query = useQuery({ 
    queryKey: ["disputeById", dispute, rp, subdomain ], 
    enabled: queryEnabled,
    queryFn: async () => {
      const result = await fetch(`/api/composite?dspid=${dispute}&rp=${rp}&subdomain=${subdomain}`)
      const data = await result.json()
      if( data.result !== "success" ) throw new Error(data.msg)
      if( callback ) callback(data)
      return data
    }
  })

  return query
}